import React, { useState } from 'react';
import { callFunction } from '../firebase';
import { useCompanySession } from '../session';
import CompanyLayout from '../components/CompanyLayout';
import { useI18n } from '../i18n';
import { moduleOn, useTenantFeatures } from '../tenantFeatures';

export const USSD_WEBHOOK_URL = 'https://pulse-insurance.web.app/hooks/ussd';

export function UssdConsole({ tenantId }) {
    const { t } = useI18n();
    const [text, setText] = useState('');
    const [reply, setReply] = useState('CON Pulse Insurance *920#\n1. Verify plate\n2. Verify policy number');
    const [busy, setBusy] = useState(false);
    const [entry, setEntry] = useState('');

    const send = async (nextText) => {
        setBusy(true);
        try {
            const data = await callFunction('ussdDemo', { text: nextText, tenantId });
            setReply((data && (data.reply || data.message)) || 'END No reply');
            setText(nextText);
        } catch (err) {
            setReply('END ' + (err.message || 'Demo unavailable'));
        }
        setBusy(false);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const value = entry.trim();
        if (!value) return;
        const next = text ? (text + '*' + value) : value;
        setEntry('');
        send(next);
    };

    return (
        <div className="bd-card" style={{ maxWidth: 560 }}>
            <h5 className="mb-2">{t('ussd.title')}</h5>
            <p className="small text-muted">{t('ussd.intro')}</p>
            <div className="border rounded p-3 mb-3 bg-dark text-success font-monospace" style={{ minHeight: 140, whiteSpace: 'pre-wrap' }}>
                {reply}
            </div>
            <div className="d-flex gap-2 flex-wrap mb-3">
                <button type="button" className="bd-btn bd-btn-secondary bd-btn-sm" disabled={busy} onClick={() => { setText(''); send(''); }}>*920#</button>
                <button type="button" className="bd-btn bd-btn-secondary bd-btn-sm" disabled={busy} onClick={() => send('1')}>1 · Plate</button>
                <button type="button" className="bd-btn bd-btn-secondary bd-btn-sm" disabled={busy} onClick={() => send('2')}>2 · Policy</button>
            </div>
            <form className="d-flex gap-2" onSubmit={onSubmit}>
                <input className="form-control" value={entry} onChange={(e) => setEntry(e.target.value.toUpperCase())} placeholder={t('ussd.entryPh')} />
                <button className="bd-btn bd-btn-primary" type="submit" disabled={busy}>{t('ussd.send')}</button>
            </form>
            <div className="alert alert-light border mt-3 mb-0 small">
                <div><strong>{t('ussd.webhook')}</strong></div>
                <code>{USSD_WEBHOOK_URL}</code>
                <div className="mt-2">{t('ussd.webhookHint')}</div>
            </div>
        </div>
    );
}

function UssdDemo() {
    const { session, loading } = useCompanySession();
    const { t } = useI18n();
    const features = useTenantFeatures(session && session.tenantId);
    if (loading || !session) return <div className="p-5">{t('common.loading')}</div>;
    if (!moduleOn(features, 'ussd')) {
        return (
            <CompanyLayout session={session}>
                <div className="alert alert-warning">{t('modules.disabled')}</div>
            </CompanyLayout>
        );
    }
    return (
        <CompanyLayout session={session}>
            <UssdConsole tenantId={session.tenantId} />
        </CompanyLayout>
    );
}

export default UssdDemo;
